export const HeaderKeys = {
  APP_ID: 'x-app-id',
  APP_SUB_ID: 'x-app-sub-id',
};
